<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('retailerManagement.recommended_list') }}</h4>
      </template>
      <template v-slot:body>
        <b-row>
            <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                <b-form-group
                    class="row"
                    label-cols-sm="3"
                    :label="$t('globalTrans.fiscal_year')"
                    label-for="type_id"
                    >
                    <b-form-select
                    plain
                    v-model="search.fiscal_year_id"
                    :options="fiscalYearList"
                    id="type_id"
                    >
                    <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                    </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
             <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                <b-form-group
                    class="row"
                    label-cols-sm="3"
                    :label="$t('retailerManagement.month')"
                    label-for="type_id"
                    >
                    <b-form-select
                    plain
                    v-model="search.month_id"
                    :options="monthList"
                    id="month_id"
                    >
                    <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                    </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
         <b-row>
            <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                <b-form-group
                    class="row"
                    label-cols-sm="3"
                    :label="$t('retailerManagement.application_type')"
                    label-for="registration_type"
                    >
                    <b-form-select
                    plain
                    v-model="search.registration_type"
                    :options="registrationTypeList"
                    id="registration_type"
                    >
                    <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                    </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col xs="12" sm="12" md="6" lg="6" xl="6">
              <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search') }}</b-button>
            </b-col>
        </b-row>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('retailerManagement.recommended_list') }}</h4>
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table thead-class="bg-primary" bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                    <template v-slot:cell(registration_number)="data">
                      <span>{{ data.item.type == 1 ? 'D-' + data.item.registration_number : 'R-'+ data.item.registration_number}}</span>
                    </template>
                    <template v-slot:cell(registration_date)="data">
                      {{ data.item.registration_date | dateFormat }}
                    </template>
                    <template v-slot:cell(type)="data">
                      <span>{{ getStoreData('registrationTypeList', data.item.type) }}</span>
                    </template>
                     <template v-slot:cell(status)="data">
                      <p :class="getColor(data.item.status)">{{ getStoreData('registrationStatusList', data.item.status) }}</p>
                    </template>
                   <template v-slot:cell(action)="data">
                      <a href="javascript:" class="btn_table_action btn_green" :title="$t('globalTrans.details')" v-b-modal.modal-detail @click="details(data.item)"><i class="fas fa-eye"></i></a>
                      <a href="javascript:" class="btn_table_action btn_purple" v-if="data.item.status !== 4 && data.item.type === 2" :title="$t('globalTrans.approve')" @click="approve(data.item, 3)"><i class="far fa-check-circle"></i></a>
                      <a href="javascript:" class="btn_table_action btn_blue" v-if="data.item.status !== 4 && (data.item.payment_status === 2 || data.item.payment_status === 1) && data.item.type === 1" :title="$t('globalTrans.approve')" @click="approve(data.item, 3)"><i class="fas fa-check-circle"></i></a>
                      <a href="javascript:" class="btn_table_action btn_deep_blue" v-if="data.item.type === 1 && data.item.payment_type_id === 2 && data.item.payment_status === 2" :title="$t('retailerManagement.payment_verify')" v-b-modal.modal-verify @click="details(data.item)"><i class="ri-checkbox-line"></i></a>
                      <a href="javascript:" class="btn_table_action btn_rad" v-if='data.item.type === 1 && data.item.status === 2 && data.item.payment_status === 0' :title="$t('externalUser.security_payment')" v-b-modal.modal-payment size="sm" @click="details(data.item)"><i class="fas fa-money-check"></i></a>
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal id="modal-detail" size="lg" :title="$t('externalUser.profile_details')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <DetailModal :id="editItemId"/>
    </b-modal>
    <b-modal id="modal-verify" size="lg" :title="$t('retailerManagement.payment_verify')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <PaymentVerify :id="editItemId"/>
    </b-modal>
    <b-modal id="modal-payment" size="lg" :title="$t('externalUser.security_payment')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <Payment :id="editItemId"/>
    </b-modal>
  </b-container>
</template>
<script>

import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { dealerRetailerRegList, dealerRetailerStatus } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import DetailModal from './DetailModal'
import PaymentVerify from './PaymentVerify'
import Payment from './addPayment'

export default {
  mixins: [ModalBaseMasterList],
   components: {
    DetailModal,
    PaymentVerify,
    Payment
  },
  data () {
    return {
      search: {
        fiscal_year_id: 0,
        fis_start_date: '',
        fis_end_date: '',
        month_id: 0,
        registration_type: 0,
        status: 2
      },
      rows: [],
      editItemId: 0
    }
  },
  computed: {
     i18 () {
      return (this.$i18n.locale === 'bn') ? 1 : 0
    },
    monthList: function () {
      return this.$store.state.commonObj.monthList
    },
    fiscalYearList: function () {
      return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0).sort((a, b) => b.value - a.value).slice(0, 5)
    },
    registrationTypeList: function () {
        return this.$store.state.ProductionService.commonObj.registrationTypeList
    },
    currentLocale () {
      return this.$i18n.locale
    },
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-center' },
          { label: this.$t('retailerManagement.registration_id'), class: 'text-center' },
          { label: this.$t('retailerManagement.registration_date'), class: 'text-center' },
          { label: this.$t('retailerManagement.registration_type'), class: 'text-center' },
          { label: this.$t('retailerManagement.name'), class: 'text-center' },
          { label: this.$t('globalTrans.status'), class: 'text-center' },
          { label: this.$t('globalTrans.action'), class: 'text-center w-20' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'registration_number' },
          { key: 'registration_date' },
          { key: 'type' },
          { key: 'name_bn' },
          { key: 'status' },
          { key: 'action' }
        ]
      } else {
        keys = [
         { key: 'index' },
          { key: 'registration_number' },
          { key: 'registration_date' },
          { key: 'type' },
          { key: 'name_en' },
          { key: 'status' },
          { key: 'action' }
        ]
      }

      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
        })
    }
  },
  watch: {
    'search.fiscal_year_id': function (newVal, oldVal) {
        if (newVal !== oldVal) {
          if (newVal !== 0) {
            this.fiscalYearDateRange(newVal)
          } else {
            this.search.fis_start_date = ''
            this.search.fis_end_date = ''
          }
        }
    }
  },
  created () {
    this.loadData()
  },
  mounted () {
  },
  methods: {
    fiscalYearDateRange (id) {
        const Date = this.$store.state.commonObj.fiscalYearList.find(item => item.value === id)
        this.search.fis_start_date = Date.start_date
        this.search.fis_end_date = Date.end_date
    },
    details (item) {
      this.editItemId = item.id
    },
    searchData () {
      this.loadData()
    },
    loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(productionServiceBaseUrl, dealerRetailerRegList, params).then(response => {
          if (response.success) {
            this.$store.dispatch('setList', response.data.data)
            this.paginationData(response.data)
          }
          this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    toggleStatusApprove (item, status) {
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.putData(productionServiceBaseUrl, `${dealerRetailerStatus}/${item.id}`, { status: status }).then(response => {
        if (response.success) {
          if (response.notification && this.$store.state.emitNotification) {
            const notification = response.notification
            this.$socket.emit('send-notification', notification)
          }
          this.$toast.success({
            title: 'Success',
            message: 'Registration Status Update Successfully',
            color: '#D6E09B'
          })
        this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: true })
        } else {}
      })
    },
    approve (item, status) {
      this.$swal({
        title: this.$t('retailerManagement.approveMsg'),
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        focusConfirm: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.toggleStatusApprove(item, status)
        }
      })
    },
    deny (item, status) {
        this.$swal({
        title: this.$t('retailerManagement.denyMsg'),
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        focusConfirm: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.toggleStatusApprove(item, status)
        }
      })
    },
    getStoreData (state, Id) {
      if (state) {
        const tmpData = this.$store.state.ProductionService.commonObj[state]
        if (typeof tmpData === 'undefined') {
          return ''
        } else {
          const data = tmpData.find(item => item.value === Id)
          if (typeof data === 'undefined') {
            return ''
          } else {
            return this.i18 ? data.text_bn : data.text_en
          }
        }
      }
    },
    getColor (status) {
      if (status === 4) {
        return 'badge badge-danger'
      } else if (status === 3) {
        return 'badge badge-success'
      } else if (status === 2) {
        return 'badge badge-info'
      } else {
        return 'badge badge-warning'
      }
    }
  }
}
</script>
<style scope='css'>
  .blink_me {
    animation: blinker 1.3s linear infinite;
    color: red;
  }
  @keyframes blinker {
    50% {
      opacity: .09;
      background-color: green;
    }
  }
</style>
